module.exports = __webpack_public_path__ + "img/premier_web.9f53c4a6.jpg";